import { render, staticRenderFns } from "./StatusPopup.vue?vue&type=template&id=2dbd1b12&scoped=true&"
import script from "./StatusPopup.vue?vue&type=script&lang=js&"
export * from "./StatusPopup.vue?vue&type=script&lang=js&"
import style0 from "./StatusPopup.vue?vue&type=style&index=0&id=2dbd1b12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd1b12",
  null
  
)

export default component.exports